import { render } from "./TabMenu.vue?vue&type=template&id=dd60d98c&scoped=true"
import script from "./TabMenu.vue?vue&type=script&lang=js"
export * from "./TabMenu.vue?vue&type=script&lang=js"

import "./TabMenu.vue?vue&type=style&index=0&id=dd60d98c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dd60d98c"]])

export default __exports__